import React from 'react'

const StaffEditForm: React.FC = () => {
  const base = 'f-staff-form'

  return <div className={base} />
}

export default StaffEditForm
